import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "stages scroll-wrapper"
}
const _hoisted_3 = { class: "stages-header" }
const _hoisted_4 = { class: "items-count" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "stage-row" }
const _hoisted_7 = { class: "stage-title" }
const _hoisted_8 = {
  key: 1,
  class: "spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    onClose: $setup.close,
    classes: "share-stage-modal"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "header" }, [
          _createElementVNode("div", { class: "modal-title" }, "Share file with stages")
        ], -1)),
        (!$setup.loadingStages)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString($setup.plural($setup.checkedStageIds.size, "stage")) + " selected", 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stages, (stage, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["stage-row-wrapper", { checked: $setup.checkedStageIds.has(stage._id) }]),
                  key: index,
                  onClick: ($event: any) => ($setup.toggleStage(stage._id, !$setup.checkedStageIds.has(stage._id)))
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode($setup["CheckboxInput"], {
                      modelValue: $setup.checkedStageIds.has(stage._id),
                      "onUpdate:modelValue": ($event: any) => ($setup.toggleStage(stage._id, $event)),
                      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createElementVNode("div", _hoisted_7, "Stage " + _toDisplayString(stage.title), 1)
                  ])
                ], 10, _hoisted_5))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8)),
        _createElementVNode("div", { class: "controls" }, [
          _createElementVNode("button", {
            class: "button default",
            onClick: $setup.close
          }, "Cancel"),
          _createElementVNode("button", {
            class: "button default primary send",
            onClick: $setup.send
          }, "Done")
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}